(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuClose = document.querySelector('[data-mobile-menu-close]');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  }

  // Search overlay toggle
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('active');
      searchOverlay.querySelector('input').focus();
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('active');
      });
    }

    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove('active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Sort functionality
  const sortSelect = document.querySelector('[data-sort-select]');

  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });

    // Set current sort option
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }

  // Vehicle filter display
  const activeFiltersContainer = document.querySelector('[data-active-filters]');
  const vehicleDisplayInFilter = activeFiltersContainer?.querySelector('[data-vehicle-display]');

  if (activeFiltersContainer && window.vehicleSelector) {
    const vehicle = window.vehicleSelector.getSelectedVehicle();

    if (vehicle && vehicle.year && vehicle.make && vehicle.model) {
      const vehicleText = `${vehicle.year} ${vehicle.make} ${vehicle.model}${vehicle.submodel ? ' ' + vehicle.submodel : ''}`;

      if (vehicleDisplayInFilter) {
        vehicleDisplayInFilter.textContent = vehicleText;
      }

      activeFiltersContainer.style.display = 'flex';

      // TODO: Implement actual vehicle filtering using product metafields
      // This would require server-side filtering or AJAX requests
      // For now, this is a UI placeholder
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var productSections = document.querySelectorAll('section.product[data-section-type="product"]');

  productSections.forEach(function (section) {
    // ---- Product data from JSON ----
    var productJsonEl = section.querySelector('[data-product-json]');
    var productData = null;
    var variants = [];

    if (productJsonEl) {
      try {
        productData = JSON.parse(productJsonEl.textContent);
        if (productData && Array.isArray(productData.variants)) {
          variants = productData.variants;
        }
      } catch (e) {
        console.error('Error parsing product JSON', e);
      }
    }

    if (productData) {
      window.productData = productData;
      window.productVariants = variants;
    }

    // ---- Image gallery: thumbnails → main image ----
    var featuredImage = section.querySelector('#product-featured-image');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.product__thumb'));

    function setActiveThumb(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      if (thumb) thumb.classList.add('active');
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var imageUrl = thumb.getAttribute('data-media-image');
        var zoomUrl = thumb.getAttribute('data-media-zoom');

        setActiveThumb(thumb);

        if (featuredImage && imageUrl) {
          featuredImage.src = imageUrl;
          if (zoomUrl && featuredImage.hasAttribute('data-zoom')) {
            featuredImage.setAttribute('data-zoom', zoomUrl);
          }
        }
      });
    });

    // ---- Quantity buttons ----
    var quantityMinus = section.querySelector('[data-quantity-minus]');
    var quantityPlus = section.querySelector('[data-quantity-plus]');
    var quantityInput = section.querySelector('#quantity');

    if (quantityMinus && quantityInput) {
      quantityMinus.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value, 10) || 1;
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }

    if (quantityPlus && quantityInput) {
      quantityPlus.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = currentValue + 1;
      });
    }

    // ---- Variant change logic (Dawn-style) ----
    var productForm = section.querySelector('#product-form');
    var variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var optionSelectors = productForm
      ? Array.prototype.slice.call(productForm.querySelectorAll('[data-option-selector]'))
      : [];

    function findVariantByOptions(selectedOptions) {
      return variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== selectedOptions.length) return false;
        for (var i = 0; i < variant.options.length; i++) {
          if (variant.options[i] !== selectedOptions[i]) return false;
        }
        return true;
      }) || null;
    }

    function findVariantById(idValue) {
      var idStr = String(idValue);
      return variants.find(function (variant) {
        return String(variant.id) === idStr;
      }) || null;
    }

    function updateMediaForVariant(variant) {
      if (!variant || !featuredImage) return;

      // Prefer mapping via featured_media.id (default Shopify behavior)
      if (variant.featured_media && variant.featured_media.id) {
        var mediaId = String(variant.featured_media.id);
        var thumbToClick = section.querySelector('.product__thumb[data-media-id="' + mediaId + '"]');
        if (thumbToClick) {
          thumbToClick.click();
          return;
        }
      }

      // Fallback: featured_image.src if present
      if (variant.featured_image && variant.featured_image.src) {
        featuredImage.src = variant.featured_image.src;
      }
    }

    function updateUIForVariant(variant) {
      if (!variant) return;

      // Variant id input
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      // Price
      var priceEl = section.querySelector('.product__price-regular');
      if (priceEl && typeof variant.price === 'number') {
        priceEl.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(variant.price / 100);
      }

      // Compare-at price
      var compareEl = section.querySelector('.product__price-compare');
      if (compareEl) {
        if (typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
          compareEl.textContent = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
          }).format(variant.compare_at_price / 100);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      // Add to cart button
      if (productForm) {
        var submitBtn = productForm.querySelector('[type="submit"]');
        if (submitBtn) {
          if (variant.available) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
          } else {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Sold Out';
          }
        }
      }

      // Media
      updateMediaForVariant(variant);
    }

    // 1) Initial sync: use current variant id if set; otherwise selected_or_first_available_variant
    if (variants.length) {
      var initialVariant = null;

      if (variantIdInput && variantIdInput.value) {
        initialVariant = findVariantById(variantIdInput.value);
      }

      if (!initialVariant && productData && productData.selected_or_first_available_variant) {
        initialVariant = findVariantById(productData.selected_or_first_available_variant.id);
      }

      if (!initialVariant) {
        initialVariant = variants[0];
      }

      updateUIForVariant(initialVariant);
    }

    // 2) Option-select based changes (dropdowns)
    if (optionSelectors.length && variants.length) {
      optionSelectors.forEach(function (select) {
        select.addEventListener('change', function () {
          var selectedOptions = optionSelectors.map(function (s) { return s.value; });
          var variant = findVariantByOptions(selectedOptions);
          if (variant) {
            updateUIForVariant(variant);
          }
        });
      });
    }

    // 3) Fallback: if configurator or other code updates the hidden id, listen for changes
    if (productForm && variantIdInput && variants.length) {
      productForm.addEventListener('change', function () {
        var variant = findVariantById(variantIdInput.value);
        if (variant) {
          updateUIForVariant(variant);
        }
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
